module.exports = "https://referendum2020-campaigns-cdn.fire-emblem-heroes.com/images/17.205cad36.png";